import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'


export const SecondMarketGlassWarning = ({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) => {
  return <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
    <ModalOverlay />

    <ModalContent>
      <ModalCloseButton />

      <ModalHeader>Ocenění skla</ModalHeader>

      <ModalBody py={0}>
        Upozorňujeme, že jste vybral/a cenu skla druhovýroby. V případě, že bude sklo měněno za originální díl bude vybraný limit pravděpodobně nedostatečný. <br /> Doporučujeme na tuto skutečnost klienta upozornit a uvést do záznamu z jednání.
      </ModalBody>

      <ModalFooter>
        <Button colorScheme="primary" onClick={onClose}>
          Rozumím
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
}